export enum InvoiceForm {
  PAPIER = 'PAPIER',
  ELEKTRONISCH = 'ELEKTRONISCH',
}
